export const ADD_EMPLOYEE_PHOTOS = Symbol('ADD_EMPLOYEE_PHOTOS');
export const ADD_EMPLOYEE_PHOTOS_REQUEST = Symbol('ADD_EMPLOYEE_PHOTOS_REQUEST');
export const ADD_EMPLOYEE_PHOTOS_SUCCESS = Symbol('ADD_EMPLOYEE_PHOTOS_SUCCESS');
export const ADD_EMPLOYEE_PHOTOS_ERROR = Symbol('ADD_EMPLOYEE_PHOTOS_ERROR');
export const DELETE_EMPLOYEE_PHOTOS = Symbol('DELETE_EMPLOYEE_PHOTOS');
export const DELETE_EMPLOYEE_PHOTOS_REQUEST = Symbol('DELETE_EMPLOYEE_PHOTOS_REQUEST');
export const DELETE_EMPLOYEE_PHOTOS_SUCCESS = Symbol('DELETE_EMPLOYEE_PHOTOS_SUCCESS');
export const DELETE_EMPLOYEE_PHOTOS_ERROR = Symbol('DELETE_COURIER_PHOTOS_ERROR');
